export const name = 'landingPage' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
export const LandingPageAPISymbol = Symbol('LandingPageAPISymbol')
